import React from 'react';
import { Table, Button } from 'react-bootstrap';

const PendingApprovalsTable = ({
  pendingApprovals,
  handleView,
  handleApprove
}) => {
  return (
    <div className="table-responsive w-100 mb-4">
      <h5 className="mb-3 text-start" style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-main)' }}>
        Pending Foreclosure Approvals
      </h5>
      <Table className="table-list mb-0">
        <thead>
          <tr>
            <th>Member Name</th>
            <th>Outstanding Amount</th>
            <th>Total Payable</th>
            <th>Collected Cash</th>
            <th>Waiver</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {pendingApprovals.map((approval) => (
            <tr key={approval.id}>
              <td className="fw-semibold text-start ps-3">
                {approval.fk_foreclosure_approval_belongsTo_member_details_memberId?.memberName}
              </td>
              <td>₹{approval.totalOutstandingAmount}</td>
              <td className="fw-semibold" style={{ color: 'var(--primary-brand)' }}>₹{approval.totalPayableAmount}</td>
              <td className="fw-bold" style={{ color: '#166534' }}>
                ₹{approval.collectedAmount ?? approval.totalPayableAmount}
              </td>
              <td
                style={
                  Number(approval.waiverAmount) > 0
                    ? { color: "#DC2626", fontWeight: 700 }
                    : { color: "var(--text-muted)" }
                }
                title={approval.waiverReason || ""}
              >
                ₹{approval.waiverAmount ?? 0}
              </td>
              <td style={{ whiteSpace: "nowrap" }}>
                <div className="d-inline-flex gap-1 align-items-center justify-content-center">
                  <button
                    className="btn btn-sm btn-outline-primary"
                    style={{ fontSize: "0.75rem", fontWeight: 600, padding: "3px 8px" }}
                    onClick={() => handleView(approval)}
                  >
                    View
                  </button>
                  <button
                    className="btn btn-sm btn-success text-white"
                    style={{ fontSize: "0.75rem", fontWeight: 600, padding: "3px 8px" }}
                    onClick={() => handleApprove(approval.id, "Are you sure you want to Approve?", "submitAm")}
                  >
                    Approve
                  </button>
                  <button
                    className="btn btn-sm btn-warning text-dark"
                    style={{ fontSize: "0.75rem", fontWeight: 600, padding: "3px 8px" }}
                    onClick={() => handleApprove(approval.id, "Are you sure you want to Retrigger?", "retrigger")}
                  >
                    Retrigger
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default PendingApprovalsTable;